export default "__VITE_ASSET__DS_3x7Oa__"